(() => {
  if (window.cycoSmartCartLoaded) return;
  window.cycoSmartCartLoaded = true;
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  const previewId = document.querySelector('[data-cyco-preview-theme-id]')?.dataset.cycoPreviewThemeId;
  const selectors = ['.cart-items', '.subtotal-row', '[data-cyco-offer-slot]', '[data-cyco-extras-slot]', '.cart-finish'];
  const linkCard = card => {
    const handle = card.dataset.cycoProduct;
    if (!handle) return;
    const variant = card.querySelector('[data-cyco-drawer-select], [data-cyco-select]')?.value || card.querySelector('[data-cyco-drawer-add]')?.dataset.cycoDrawerAdd || card.querySelector('[data-cyco-add]')?.dataset.cycoAdd;
    const href = root + 'products/' + encodeURIComponent(handle) + (variant ? '?variant=' + encodeURIComponent(variant) : '');
    for (const element of card.querySelectorAll('h3, img')) {
      let link = element.closest('a');
      if (!link) { link = document.createElement('a'); element.before(link); link.append(element); }
      link.href = href;
      link.classList.add('cyco-cart-card__product-link');
    }
  };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const status = (message, error = false) => {
    const node = document.querySelector('[data-cyco-smart-status]');
    if (!node) return;
    node.textContent = message;
    node.hidden = !message;
    node.classList.toggle('is-error', error);
  };
  const refresh = (sections, sectionId) => {
    const html = sections?.[sectionId];
    if (!html) return false;
    const page = parse(html);
    const currentCart = document.querySelector('[data-section-type="cart"]');
    if (!page.querySelector('.cart-items') || !currentCart) return false;
    for (const selector of selectors) {
      const current = currentCart.querySelector(selector);
      const next = page.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    }
    if (sections.header) {
      const header = parse(sections.header);
      for (const selector of ['.page-header .header-cart', '.docked-navigation-container .header-cart']) {
        const next = header.querySelector(selector);
        if (next) document.querySelectorAll(selector).forEach(node => { node.innerHTML = next.innerHTML; });
      }
    }
    currentCart.querySelectorAll('[data-cyco-card]').forEach(linkCard);
    return true;
  };
  const getSections = async (sectionId) => {
    const url = new URL(`${root}cart`, window.location.origin);
    url.searchParams.set('sections', `${sectionId},header`);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error('refresh');
    return response.json();
  };
  document.querySelectorAll('[data-cyco-card]').forEach(linkCard);
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cyco-select]');
    if (!select) return;
    const card = select.closest('[data-cyco-card]');
    const button = card.querySelector('[data-cyco-add]');
    const option = select.selectedOptions[0];
    if (!button) return;
    button.dataset.cycoAdd = select.value;
    button.disabled = !select.value;
    const variantLabel = card.querySelector('.cyco-cart-card__variant');
    if (variantLabel && option) variantLabel.textContent = option.dataset.variantTitle || option.textContent;
    if (option?.dataset.price) card.querySelector('.cyco-cart-card__price').textContent = option.dataset.price;
    linkCard(card);
    if (option?.dataset.image) { const image = card.querySelector('img'); if (image) { image.src = option.dataset.image; image.removeAttribute('srcset'); image.alt = `${card.querySelector('h3').textContent} — ${option.textContent}`; } }
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cyco-add]');
    const widget = button?.closest('cyco-smart-cart');
    if (!button || !widget) return;
    event.preventDefault();
    if (busy) return;
    const card = button.closest('[data-cyco-card]');
    const sectionId = widget.dataset.sectionId;
    const variantId = button.dataset.cycoAdd;
    const staleQuantity = [...document.querySelectorAll('.quantity__number')].some(input => input.value !== input.dataset.initialValue);
    if (staleQuantity) { status(widget.dataset.wait); return; }
    busy = true;
    let added = false;
    const controls = [...document.querySelectorAll('[data-cyco-add], .quantity__number, [name="checkout"]')];
    const previous = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    document.querySelector('[data-section-type="cart"]')?.setAttribute('aria-busy', 'true');
    status(widget.dataset.adding);
    try {
      const before = await getSections(sectionId);
      const fresh = parse(before[sectionId] || '');
      const validCard = [...fresh.querySelectorAll('[data-cyco-card]')].find(node =>
        node.dataset.cycoProduct === card.dataset.cycoProduct &&
        node.dataset.cycoKind === card.dataset.cycoKind &&
        node.dataset.cycoParentKey === card.dataset.cycoParentKey &&
        ([...node.querySelectorAll('[data-cyco-add]')].some(add => add.dataset.cycoAdd === variantId) ||
        [...node.querySelectorAll('[data-cyco-select] option')].some(option => option.value === variantId))
      );
      if (!validCard) {
        refresh(before, sectionId);
        status(widget.dataset.stale, true);
        return;
      }
      const properties = { _cyco_addon_rule: card.dataset.cycoKind, _cyco_addon_source: 'cart' };
      if (card.dataset.cycoKind === 'clasp' && card.dataset.cycoParentKey) { properties._cyco_cart_parent_key = card.dataset.cycoParentKey; properties._cyco_parent_variant_id = card.dataset.cycoParentKey.split(':')[0]; }
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties }], sections: [sectionId, 'header'], sections_url: `${root}cart${previewId ? `?preview_theme_id=${previewId}` : ''}` })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || widget.dataset.error);
      added = true;
      if (!refresh(data.sections, sectionId)) {
        const after = await getSections(sectionId);
        if (!refresh(after, sectionId)) throw new Error('refresh');
      }
      status(widget.dataset.success);
      document.dispatchEvent(new CustomEvent('cyco:cart-addon-added', { detail: { product: card.dataset.cycoProduct, rule: card.dataset.cycoKind } }));
    } catch (error) {
      if (added) {
        status(widget.dataset.success);
        window.location.assign(`${root}cart`);
      } else {
        status(error.message === 'refresh' ? widget.dataset.error : error.message, true);
      }
    } finally {
      busy = false;
      controls.forEach((control, index) => { if (control.isConnected) control.disabled = previous[index]; });
      document.querySelector('[data-section-type="cart"]')?.removeAttribute('aria-busy');
    }
  });
})();
